import React from "react"

import { s } from "../../../../../utilities/common"

export const PauseIcon = () => (
  <svg
    width={s("40")}
    height={s("40")}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.583 31.667C23.8057 31.667 23.146 31.396 22.604 30.854C22.0627 30.3127 21.792 29.653 21.792 28.875V11.125C21.792 10.347 22.0627 9.68733 22.604 9.146C23.146 8.604 23.8057 8.333 24.583 8.333H28.875C29.653 8.333 30.3127 8.604 30.854 9.146C31.396 9.68733 31.667 10.347 31.667 11.125V28.875C31.667 29.653 31.396 30.3127 30.854 30.854C30.3127 31.396 29.653 31.667 28.875 31.667H24.583ZM11.125 31.667C10.347 31.667 9.68734 31.396 9.14601 30.854C8.60401 30.3127 8.33301 29.653 8.33301 28.875V11.125C8.33301 10.347 8.60401 9.68733 9.14601 9.146C9.68734 8.604 10.347 8.333 11.125 8.333H15.417C16.1943 8.333 16.854 8.604 17.396 9.146C17.9373 9.68733 18.208 10.347 18.208 11.125V28.875C18.208 29.653 17.9373 30.3127 17.396 30.854C16.854 31.396 16.1943 31.667 15.417 31.667H11.125Z"
      fill="#FFED00"
    />
  </svg>
)
